import { Flex, FlexProps } from "@chakra-ui/react";

import { OFIconButton } from "design_system/components/IconButton";
import { OFText } from "design_system/components/OFText";
import { MinusIcon, PlusIcon } from "design_system/icons";
import { colors } from "src/colors";

import { IconButtonVariantType } from "../IconButton/icon-button";

type Props = FlexProps & {
  onPlusClick: () => void;
  onMinusClick: () => void;
  number: number;
};

const iconSize = 30;
const buttonSize = 40;
const buttonProps = {
  h: `${buttonSize}px`,
  w: `${buttonSize}px`,
  minW: `${buttonSize}px`,
  variant: "secondary" as IconButtonVariantType
};

export const OFQuantityCounter = ({ number, onMinusClick, onPlusClick, ...props }: Props) => {
  return (
    <Flex
      p="6px 8px"
      alignItems="center"
      gap="10px"
      borderColor={colors.grey[500]}
      border="1px solid"
      borderRadius="8px"
      {...props}
    >
      <OFIconButton
        arialLabel="Minus"
        {...buttonProps}
        icon={<MinusIcon size={iconSize} />}
        onClick={onMinusClick}
      />
      <OFText textStyle="body3" color={colors.black[900]}>
        {number}
      </OFText>
      <OFIconButton
        arialLabel="Plus"
        {...buttonProps}
        icon={<PlusIcon size={iconSize} onClick={onPlusClick} />}
      />
    </Flex>
  );
};
